import { render, staticRenderFns } from "./frame.vue?vue&type=template&id=2600470a&scoped=true&"
import script from "./frame.vue?vue&type=script&lang=js&"
export * from "./frame.vue?vue&type=script&lang=js&"
import style0 from "./frame.vue?vue&type=style&index=0&id=2600470a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2600470a",
  null
  
)

export default component.exports